module.exports = __webpack_public_path__ + "static/media/7ICJ1.2a6485c1.jpg";